import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { FaWhatsapp } from "react-icons/fa";
import styled from "styled-components";
import { trackClipSocialShare, trackCreatorCardShare } from "./utils";

const StyledShare = styled(FaWhatsapp)`
  color: #f8fcfd;
`;

export default function WhatsAppShare({ link, clip, card, ...props }) {
  return (
    <>
      <ShareButton
        title="Share to WhatsApp"
        justifyContent={"center"}
        alignItems="center"
        flex={true}
        display="flex"
        href={`https://api.whatsapp.com/send/?phone&text=${link}`}
        target="_blank"
        onClick={() => {
          if (clip) {
            trackClipSocialShare({
              platform: "WhatsApp",
              isMontage: clip.isMontage,
              clip,
            });
          } else if (card) {
            trackCreatorCardShare(card);
          }
        }}
        {...props}
      >
        <StyledShare size={24}></StyledShare>

        {props.children}
      </ShareButton>
    </>
  );
}
